/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

import MuLogo from '../../assets/images/mu-logo.jpeg';
import RmLogo from '../../assets/images/rm-logo.jpeg';
import JuLogo from '../../assets/images/ju-logo.jpeg';
import BmLogo from '../../assets/images/bm-logo.jpeg';

export const videos = [
  {
    _id: "muGyJEu12A8",
    alt: 'football club videos',
    title: "The NEW & FUTURE Santiago Bernabéu Stadium",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=muGyJEu12A8&list=PLFA93DC971607A2CB&index=1',
    views: '5,050,253 views',
    likes: '134K',
    postedOn: 'Sep 23, 2018',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/muGyJEu12A8/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB0sU5CUaDnv2rS1GNa5b_3N8IVxw'
  },
  {
    _id: "5hFd6zGkxLE",
    alt: 'football club videos',
    title: "THANK YOU, CRISTIANO RONALDO | Real Madrid Official Video",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=5hFd6zGkxLE&list=PLFA93DC971607A2CB&index=8',
    views: '47,854,676 views',
    likes: '2.4M',
    postedOn: 'Jul 10, 2018',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/5hFd6zGkxLE/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBQTi6Yt-PnHbrUaMNIEjlxqfXLIA',
    description: "Real Madrid C. F. inform that, as per Cristiano Ronaldo's wishes and at his request, the club has allowed the player to complete his move to Juventus F. C.Real Madrid would today like to place on record its thanks to a player who has shown himself to be the best in the world and made his mark on one of the greatest periods in our club's history and on the world game.Apart from the titles he has lifted, the honours secured and the on-field achievements during these nine years, Cristiano Ronaldo has been a role model in terms of commitment, hard work, responsibility, talent and self-improvement.He became Real Madrid's leading all-time goalscorer, having scored 451 goals in his 438 appearances. In total, he won 16 pieces of silverware, including four European Cup crowns, three of which came in successive years, with these four continental triumphs coming in the past five seasons. In terms of individual honours, as a Real Madrid player, he won the Ballon d'Or on four occasions, The Best award twice and claimed the Golden Shoe three times, amongst many other accoladesCristiano Ronaldo will forever be one of Real Madrid's biggest icons and will represent a unique figure for future generations.Real Madrid will always be his home."
  },
  {
    _id: "dLdW5SOkao4",
    alt: 'football club videos',
    title: "ZINEDINE ZIDANE | The return of a Real Madrid hero",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=dLdW5SOkao4&list=PLFA93DC971607A2CB&index=13',
    views: '560,416 views',
    likes: '27K',
    postedOn: 'March 12, 2019',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/dLdW5SOkao4/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAyF6I8gaf2ARPMAEAEo7YZFYNJDw'
  },
  {
    _id: "Yc-7IQqcqeM",
    alt: 'football club videos',
    title: "Hala Madrid...y nada más (feat. RedOne)",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=Yc-7IQqcqeM&list=PLFA93DC971607A2CB&index=60',
    views: '7,912,986 views',
    likes: '232K',
    postedOn: 'May 27, 2014',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/Yc-7IQqcqeM/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBPDU0PiMXxs6E6IhQL-u3aULdxww'
  },
  {
    _id: "04Q6ybR1bLc",
    alt: 'football club videos',
    title: "Best TACKLES AND BLOCKS | Sergio Ramos x Real Madrid",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=04Q6ybR1bLc&list=PLaI5lCKwq3IcjMspWSu4djRtrrCSC61Ht&index=1',
    views: '452,440 views',
    likes: '17K',
    postedOn: 'June 18, 2021',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/04Q6ybR1bLc/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBIF32zzANx_SHpVaqzwZ_T9SE0tQ'
  },
  {
    _id: "H0GVemJOmIg",
    alt: 'football club videos',
    title: "Sergio Ramos, ALL CHAMPIONS LEAGUE goals | Real Madrid",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=H0GVemJOmIg&list=PLaI5lCKwq3IcjMspWSu4djRtrrCSC61Ht&index=2',
    views: '174,672 views',
    likes: '11K',
    postedOn: 'June 18, 2021',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/H0GVemJOmIg/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCE9q_Zo_6YFEKiJ6-vNnqsS1DI7w'
  },
  {
    _id: "X-Dp19wIKhE",
    alt: 'football club videos',
    title: "THANK YOU, SERGIO RAMOS | Real Madrid Legend",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=X-Dp19wIKhE&list=PLaI5lCKwq3IcjMspWSu4djRtrrCSC61Ht&index=5',
    views: '3,124,007 views',
    likes: '244K',
    postedOn: 'June 17, 2021',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/X-Dp19wIKhE/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDytAWrsMO7ot-tciSXeehCY5xlSQ'
  },
  {
    _id: "4H1gCbxa_ls",
    alt: 'football club videos',
    title: "Real Madrid's Champions League dressing room celebrations!",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=4H1gCbxa_ls',
    views: '4,986,669 views',
    likes: '191K',
    postedOn: 'May 29, 2022',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/4H1gCbxa_ls/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLClJWyDHUinCQFN0g3F1hdw-PgH8A'
  },
  {
    _id: "84HI6VtrocQ",
    alt: 'football club videos',
    title: "RONALDO and teammates take you through our victory in Paris against PSG",
    creator: "Real Madrid",
    videoUrl: 'https://www.youtube.com/watch?v=84HI6VtrocQ',
    views: '4,675,564 views',
    likes: '58K',
    postedOn: 'Mar 08, 2018',
    type: 'rm',
    avatar: RmLogo,
    thumbnail: 'https://i.ytimg.com/vi/84HI6VtrocQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLC_GdOJUAFVjH7kZfXqm93qqZXOqQ'
  },
  {
    _id: "hxzVIiGT_f8",
    alt: 'football club videos',
    title: "REACTION: Reds agree Cristiano Ronaldo deal | Manchester United",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=hxzVIiGT_f8&list=PL5-QUghxmluI47lAbIq0F4pSoYdniOMYI&index=4',
    views: '2,327,523 views',
    likes: '123K',
    postedOn: 'August 28, 2021',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/hxzVIiGT_f8/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA-b7-PC-UF38qC5eRr9F1gtcpLww',
    avatar: MuLogo
  },
  {
    _id: "922h6L3ZjO0",
    alt: 'football club videos',
    title: "Ryan Giggs | Manchester United Greats",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=922h6L3ZjO0&list=PL5-QUghxmluKPt9CO9kZ1Y09itF158Z42&index=14',
    views: '166,193 views',
    likes: '5.4K',
    postedOn: 'March 11, 2018',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/922h6L3ZjO0/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBvz_Xwml38cDqF_5cBydy4HY8BOA',
    avatar: MuLogo
  },
  {
    _id: "2rOKggB6fnQ",
    alt: 'football club videos',
    title: "Paul Scholes | Manchester United Greats",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=2rOKggB6fnQ&list=PL5-QUghxmluKPt9CO9kZ1Y09itF158Z42&index=12',
    views: '178,314 views',
    likes: '4.1K',
    postedOn: 'Feb 22, 2018',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/2rOKggB6fnQ/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBe9QMEIlaUR_DkQJNcqJyf4Yce1g',
    avatar: MuLogo
  },
  {
    _id: "xEfwVQpHLio",
    alt: 'football club videos',
    title: "Ji-sung Park | Manchester United Greats",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=xEfwVQpHLio',
    views: '1,134,651 views',
    likes: '29K',
    postedOn: 'May 8, 2018',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/xEfwVQpHLio/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCgKHWH2hgE1CDHtuv3KLkB5qGMeA',
    avatar: MuLogo
  },
  {
    _id: "BiWafKt68eI",
    alt: 'football club videos',
    title: "David Beckham | Manchester United Greats",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=BiWafKt68eI&list=PL5-QUghxmluKPt9CO9kZ1Y09itF158Z42&index=11',
    views: '222,405 views',
    likes: '5.1K',
    postedOn: 'Feb 22, 2018',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/BiWafKt68eI/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD1HD_u8S9CcN5GxE4HhGqIQkoiJg',
    avatar: MuLogo
  },
  {
    _id: "Ahnby2vUlxM",
    alt: 'football club videos',
    title: "Ronaldo strikes double on his return to OT",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=Ahnby2vUlxM',
    views: '20,504,299 views',
    likes: '492K',
    postedOn: 'Sep 12, 2021',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/Ahnby2vUlxM/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAdl5PKaFOmj2tTD2e0XF8QjtcywQ',
    avatar: MuLogo
  },
  {
    _id: "qsyFbyX5PuY",
    alt: 'football club videos',
    title: "Ronaldo stars as United beat 10-man Liverpool",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=qsyFbyX5PuY',
    views: '11,017,739 views',
    likes: '142K',
    postedOn: 'Feb 23, 2019',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/qsyFbyX5PuY/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAABZ3Stdncy9KgfR5syxWrLCaHHw',
    avatar: MuLogo
  },
  {
    _id: "ZE-GjQy-PLc",
    alt: 'football club videos',
    title: "Robin van Persie | All Premier League Goals | Manchester United",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=ZE-GjQy-PLc',
    views: '9,861,176 views',
    likes: '110K',
    postedOn: 'Mar 23, 2018',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/ZE-GjQy-PLc/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAsHgcUkiYL44ED54_S2ZJDDPnL3Q',
    avatar: MuLogo
  },
  {
    _id: "AmHsd9NG_fs",
    alt: 'football club videos',
    title: "Ronaldo hat-trick seals vital win! | Manchester United 3-2 Tottenham | Highlights | Premier League",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=AmHsd9NG_fs',
    views: '9,406,993 views',
    likes: '263K',
    postedOn: 'Mar 13, 2022',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/AmHsd9NG_fs/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA8oGnMiif67P8XYAJwXP9GjBbUfA',
    avatar: MuLogo
  },
  {
    _id: "-_EVfrXqkEo",
    alt: 'football club videos',
    title: "Cristiano Ronaldo Hat-Trick! | Manchester United 3-2 Norwich | Highlights",
    creator: "Manchester United",
    videoUrl: 'https://www.youtube.com/watch?v=-_EVfrXqkEo',
    views: '9,234,189 views',
    likes: '230K',
    postedOn: 'Apr 17, 2022',
    type: 'mu',
    thumbnail: 'https://i.ytimg.com/vi/-_EVfrXqkEo/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD2QdmOXe4zaLbKbjLyBgG46-q5Bw',
    avatar: MuLogo
  },
  {
    _id: "chq-NNOQV50",
    alt: 'football club videos',
    title: "Ciao, Cristiano! | Juventus says goodbye to Cristiano Ronaldo | Juventus",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=chq-NNOQV50',
    views: '513,905 views',
    likes: '46K',
    postedOn: 'August 31, 2021',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/pMuoNqz-LK8/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA1EpcgvJctDmNDcHoX_PzIRg3jVQ',
    avatar: JuLogo
  },
  {
    _id: "cLfSpFg6Pxg",
    alt: 'football club videos',
    title: "HIGHLIGHTS: Juventus vs Atletico Madrid - 3-0 - Ronaldo hat-trick completes comeback!",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=cLfSpFg6Pxg',
    views: '11,460,498 views',
    likes: '192K',
    postedOn: 'March 16, 2019',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/cLfSpFg6Pxg/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDNaBd_39KT-jmSGx2deoIQJcmmgQ',
    avatar: JuLogo
  },
  {
    _id: "p5HFfvkR9t4",
    alt: 'football club videos',
    title: "Cristiano Ronaldo arrives at J|Medical | #CR7DAY | Juventus!",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=p5HFfvkR9t4',
    views: '3,355,175 views',
    likes: '68K',
    postedOn: 'July 16, 2018',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/hgB9rLdJDWE/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAaiGr0TF10mbgqwHxHui2k3dhe8A',
    avatar: JuLogo
  },
  {
    _id: "8PuCoI5H5dQ",
    alt: 'football club videos',
    title: "Juventus Doubles Volley Challenge!",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=8PuCoI5H5dQ',
    views: '9,535,205 views',
    likes: '62K',
    postedOn: 'August 29, 2018',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/8PuCoI5H5dQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDGGohreY4aNGwuR3O8ViX-xMl3Vw',
    avatar: JuLogo
  },
  {
    _id: "hh--jwht7Oo",
    alt: 'football club videos',
    title: "The International Juventus Players Check in to Medical | Juventus",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=hh--jwht7Oo',
    views: '4,614,070 views',
    likes: '46K',
    postedOn: 'July 30, 2018',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/hh--jwht7Oo/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCio0DqgfikJg9zhbRwyCfo2GwItw',
    avatar: JuLogo
  },
  {
    _id: "mdjgXTiTACE",
    alt: 'football club videos',
    title: "Juventus Shot Challenge: Allegri vs Pogba",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=mdjgXTiTACE',
    views: '7,482,919 views',
    likes: '63K',
    postedOn: 'Jan 29, 2015',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/mdjgXTiTACE/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB3BkvmsNZnrGVmonfCk_sDj-czSA',
    avatar: JuLogo
  },
  {
    _id: "CfnsrX3TXX0",
    alt: 'football club videos',
    title: "Juventus, Tevez super strike.",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=CfnsrX3TXX0',
    views: '1,941,471 views',
    likes: '37K',
    postedOn: 'Feb 06, 2014',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/CfnsrX3TXX0/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLARcdCvrIJFGBB5rDqDufYDevYR1A',
    avatar: JuLogo
  },
  {
    _id: "DHKx20X4_HM",
    alt: 'football club videos',
    title: "The Best of Pavel Nedvěd | Unstoppable Goals & Incredible Dribbling! | Juventus",
    creator: "Juventus",
    videoUrl: 'https://www.youtube.com/watch?v=DHKx20X4_HM',
    views: '1,317,753 views',
    likes: '28K',
    postedOn: 'Aug 30, 2020',
    type: 'ju',
    thumbnail: 'https://i.ytimg.com/vi/DHKx20X4_HM/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAgxkKelaW7B9EbHSTpMQLgJJ9kjg',
    avatar: JuLogo
  },
  {
    _id: "_Q_b-42w7HI",
    alt: 'football club videos',
    title: "Lewandowski vs. Müller | Copy the Penalty Challenge",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=_Q_b-42w7HI',
    views: '16,935,651 views',
    likes: '388K',
    postedOn: 'July 15, 2020',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/_Q_b-42w7HI/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCVMoBat6p07v3ryj9CDDrRllgajA',
    avatar: BmLogo
  },
  {
    _id: "l03qv1y4FXs",
    alt: 'football club videos',
    title: "7 Championships, 7 Beer Showers | Best of FC Bayern",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=l03qv1y4FXs',
    views: '10,811,466 views',
    likes: '94K',
    postedOn: 'May 22, 2019',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/l03qv1y4FXs/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCPzaIWblaWgULdvmVT39B9lSS_bw',
    avatar: BmLogo
  },
  {
    _id: "XE-c0-X5pVA",
    alt: 'football club videos',
    title: "Franck Ribéry's Emotional Goodbye at FC Bayern",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=XE-c0-X5pVA',
    views: '10,730,397 views',
    likes: '242K',
    postedOn: 'May 21, 2019',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/XE-c0-X5pVA/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBfEtKRWHRDn7rQOZjsyuumYEMxVA',
    avatar: BmLogo
  },
  {
    _id: "poKcrN-VpiM",
    alt: 'football club videos',
    title: "Bayern Challenge feat. Franck Ribéry & Arjen Robben | FC Bayern",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=poKcrN-VpiM',
    views: '10,207,002 views',
    likes: '158K',
    postedOn: 'May 30, 2019',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/poKcrN-VpiM/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDUlvyavwSzOfO04823L5Heoik8xA',
    avatar: BmLogo
  },
  {
    _id: "2SnX-lRiZzc",
    alt: 'football club videos',
    title: "Manuel Neuer's impressive training at Lake Tegernsee | FC Bayern",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=2SnX-lRiZzc',
    views: '8,002,005 views',
    likes: '125K',
    postedOn: 'May 6, 2020',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/2SnX-lRiZzc/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAxoifggg0FWV-te4ejo_mejNo_OQ',
    avatar: BmLogo
  },
  {
    _id: "EupCe8TJITg",
    alt: 'football club videos',
    title: "Arjen Robben's best goals for FC Bayern",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=EupCe8TJITg',
    views: '6,423,190 views',
    likes: '118K',
    postedOn: 'Jan 23, 2019',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/EupCe8TJITg/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDsTU45XjFgD_GF22HnaauA5dBSuQ',
    avatar: BmLogo
  },
  {
    _id: "nMAjDtr1GoI",
    alt: 'football club videos',
    title: "Oliver Kahn - Top 10 Saves for FC Bayern",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=nMAjDtr1GoI',
    views: '6,306,429 views',
    likes: '92K',
    postedOn: 'Jun 15, 2019',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/nMAjDtr1GoI/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAied898atJKnt54zgerq4DpCSamw',
    avatar: BmLogo
  },
  {
    _id: "Uwgk3NCPoJQ",
    alt: 'football club videos',
    title: "Exclusive Insight: Bayern's Champions League celebrations in the changing room",
    creator: "Bayern Munich",
    videoUrl: 'https://www.youtube.com/watch?v=Uwgk3NCPoJQ',
    views: '3,401,220 views',
    likes: '84K',
    postedOn: 'Aug 24, 2020',
    type: 'bm',
    thumbnail: 'https://i.ytimg.com/vi/Uwgk3NCPoJQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDEnrDm-p9vEP8ailw23LRqe86ugQ',
    avatar: BmLogo
  },
];
